<template>
  <div class="layout">
    <router-view/>
  </div>
</template>
<style lang="less">
#application-name{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.layout {
  height: 100%;
  box-sizing: border-box;
}
</style>
